import { Injectable } from '@angular/core';
import { RealEstateFilterOffices } from '@app-model/promotedContent';
import { RealEstateService } from '@app-services/realEstate.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RealEstateOfficeOptionsService {
	constructor(private readonly realEstateService: RealEstateService) {}

	searchOffices(entityType: string, entityId: string, searchTerm: string = ''): Observable<RealEstateFilterOffices[]> {
		return this.realEstateService
			.getFilterOffices(entityType, entityId, {
				page: 0,
				pageSize: 50,
				param: 'name',
				value: searchTerm.trim(),
				sortDirection: 'ASC',
				sortField: 'name'
			})
			.pipe(map(response => response?.data ?? []));
	}
}
